export enum HeaderPopupKey {
  Queue = 'Queue',
  EventTime = 'EventTime',
  History = 'History',
  ConfirmIncidents = 'ConfirmIncidents',
  EventStatus = 'EventStatus',
  Notifications = 'Notifications',
}
